import Form from "react-bootstrap/Form";
import React, { useEffect, useState} from "react";
import axios from 'axios';
import './VideoLinkInput.css'
import apiUrl from "../../../shared/config";

// Regex for validating the video ID
const idRegex = /^[\w-]{11}$/;

// Regex patterns for YouTube and Steam URLs
const standardYouTubePattern = /youtube\.com\/watch\?v=([^&]+)/;
const shortenedYouTubePattern = /youtu\.be\/([^?]+)/;
const steamVideoPattern = /^https?:\/\/(?:[a-zA-Z0-9-]+\.)?akamai\.steamstatic\.com\/.*\.(webm|mp4|ogv)(\?.*)?$/i;

function getVideoInfo(id, signal) {
    let videoInfoResponse = {
        existing: false,
        validId: false,
        private: undefined,
        info: undefined,
    };

    if (idRegex.test(id)) {
        videoInfoResponse.validId = true;
        return axios
            .request({
                url: 'oembed',
                baseURL: 'https://www.youtube.com/',
                params: {
                    url: `https://youtu.be/${id}`,
                    format: 'json',
                },
                validateStatus: (status) => status === 200 || status === 404 || status === 401,
                signal, // Pass the signal to Axios
            })
            .then((response) => {
                if (response.status === 200) {
                    videoInfoResponse.existing = true;
                    videoInfoResponse.private = false;
                    videoInfoResponse.info = {
                        title: response.data.title,
                        author: {
                            name: response.data.author_name,
                            url: response.data.author_url,
                        },
                    };
                } else if (response.status === 401) {
                    videoInfoResponse.existing = true;
                    videoInfoResponse.private = true;
                }
                return videoInfoResponse;
            })
            .catch((error) => {
                if (axios.isCancel(error)) {
                    console.log('Request canceled:', error.message);
                } else {
                    throw error;
                }
            });
    } else {
        return Promise.resolve(videoInfoResponse);
    }
}

async function checkSteamVideoLink(videoUrl) {
    try {
        const response = await axios.get(apiUrl + "Games/checkSteamLink?url=" + videoUrl);
        return response.data && response.data.exists === true;
    } catch (e) {
        return false; // Return false in case of any error
    }
}

const VideoLinkInput = ({ update, value, updateValid }, ref) => {
    const [isValidLink, setIsValidLink] = useState(0); // 0: Checking, 1: Valid, -1: Invalid

    useEffect(() => {
        const controller = new AbortController();
        const signal = controller.signal;

        const validateLink = async (url) => {
            let embedUrl = '';
            if (url === '') {
                setIsValidLink(-2);
                return;
            }
            setIsValidLink(0); // set to 0 while waiting for evaluation

            if (steamVideoPattern.test(url)) {
                // steam link doesn't enable same checking so give the user a warning.
                if(await checkSteamVideoLink(url)) {
                    setIsValidLink(2);
                } else {
                    setIsValidLink(-1);
                }
                return;
            } else if (shortenedYouTubePattern.test(url)) {
                const match = url.match(shortenedYouTubePattern);
                embedUrl = match[1];
            } else if (standardYouTubePattern.test(url)) {
                const match = url.match(standardYouTubePattern);
                embedUrl = match[1];
            } else {
                embedUrl = value;
            }
                try {
                    const videoInfo = await getVideoInfo(embedUrl, signal);
                    if (videoInfo.existing && videoInfo.validId) {
                        setIsValidLink(1);
                    } else {
                        setIsValidLink(-1);
                    }
                } catch (error) {
                    if (axios.isCancel(error)) {
                        console.log("Request was cancelled.");
                    } else {
                        setIsValidLink(-1);
                    }
                }
        };

        // Validate the link
        validateLink(value);

        // Cleanup function to cancel the request on component unmount or value change
        return () => {
            controller.abort();
        };
    }, [value]);

    useEffect(() => {
        updateValid(isValidLink === 1 || isValidLink === 2 || isValidLink === -2)
    }, [updateValid ,isValidLink]);


    function getText() {
        if (isValidLink === 0) {
            return (
                <p className={"video-status-message video-checking"}>
                    Checking Link Validity
                </p>
            );
        } else if (isValidLink === 1) {
            return (
                <p className={"video-status-message video-valid"}>
                    Link Is Valid
                </p>
            );
        } else if (isValidLink === 2) {
            return <p className={"video-status-message video-recommendation"}>
                Steam Link Exists. Ensure the video loads properly on the game page.
            </p>
        } else if (isValidLink === -2) {
            return <p className="video-status-message">
                &nbsp;&nbsp;&nbsp;
            </p>
        } else {
            return (
                <p className={"video-status-message video-invalid"}>
                Link Is Invalid
                </p>
            );
        }
    }

    const text = getText();

    return (
        <>
            <Form.Control
                type="text"
                placeholder="Input a YouTube video link, YouTube video code, or a Steam link"
                value={value}
                onChange={update}
            />
            {text}
        </>
    );
};

export default VideoLinkInput;
